import { render, staticRenderFns } from "./fyzc.vue?vue&type=template&id=93314e9a&"
import script from "./fyzc.vue?vue&type=script&lang=js&"
export * from "./fyzc.vue?vue&type=script&lang=js&"
import style0 from "./fyzc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports